import { ApprovalConsiderationAnnounceFourContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFourContainer';

export function ApprovalConsiderationAnnounceFourPage() {
    return (
        <ApprovalConsiderationAnnounceFourContainer />
    )
}